import React from 'react'
import { VegaTypo } from '../../vega/typography/Typography'
import style from './paymentInfo.module.scss'

export const PaymentInfoHeader = ({ paymentId, statusLabel }) => {
	return (
		<>
			<div className={style.paymentId}>
				<VegaTypo label={paymentId && `#${paymentId}`} />
			</div>
			<div className={style.paymentStatus}>
				<VegaTypo label={statusLabel} />
			</div>
		</>
	)
}
